// Generated TypeScript types from Pydantic models
// Source: src/backend/models.py
// Generated on: 2026-06-29T09:36:18.093865
// DO NOT EDIT MANUALLY - This file is auto-generated

// Types are implemented in generated/types.generated.ts.
// This small facade keeps imports stable while satisfying file-size limits.

export type AIModelType = import('./generated/types.generated').AIModelType;
export type ActivityType = import('./generated/types.generated').ActivityType;
export type ApiActivityType = import('./generated/types.generated').ApiActivityType;
export type ApiMessageType = import('./generated/types.generated').ApiMessageType;
export type ApiStatusType = import('./generated/types.generated').ApiStatusType;
export type ApplicationStatus = import('./generated/types.generated').ApplicationStatus;
export type ChatContextType = import('./generated/types.generated').ChatContextType;
export type ChatSenderType = import('./generated/types.generated').ChatSenderType;
export type ColorBlindMode = import('./generated/types.generated').ColorBlindMode;
export type DataSourceType = import('./generated/types.generated').DataSourceType;
export type DocumentType = import('./generated/types.generated').DocumentType;
export type EmploymentType = import('./generated/types.generated').EmploymentType;
export type FontSize = import('./generated/types.generated').FontSize;
export type InterviewRecommendation = import('./generated/types.generated').InterviewRecommendation;
export type InterviewType = import('./generated/types.generated').InterviewType;
export type LanguageProficiency = import('./generated/types.generated').LanguageProficiency;
export type MFAMethod = import('./generated/types.generated').MFAMethod;
export type NotificationType = import('./generated/types.generated').NotificationType;
export type ProcessingStepType = import('./generated/types.generated').ProcessingStepType;
export type SalaryPeriod = import('./generated/types.generated').SalaryPeriod;
export type SearchType = import('./generated/types.generated').SearchType;
export type SkillLevel = import('./generated/types.generated').SkillLevel;
export type SkillStatus = import('./generated/types.generated').SkillStatus;
export type SkillStrength = import('./generated/types.generated').SkillStrength;
export type SocialPlatform = import('./generated/types.generated').SocialPlatform;
export type SortOrder = import('./generated/types.generated').SortOrder;
export type ThemePreference = import('./generated/types.generated').ThemePreference;
export type UserGender = import('./generated/types.generated').UserGender;
export type UserStatus = import('./generated/types.generated').UserStatus;
export type UserType = import('./generated/types.generated').UserType;
export type VectorStoreType = import('./generated/types.generated').VectorStoreType;
export type AccessibilitySettings = import('./generated/types.generated').AccessibilitySettings;
export type Analytics = import('./generated/types.generated').Analytics;
export type ApiMessage = import('./generated/types.generated').ApiMessage;
export type ApiResponse = import('./generated/types.generated').ApiResponse;
export type ApplicationDecision = import('./generated/types.generated').ApplicationDecision;
export type Attachment = import('./generated/types.generated').Attachment;
export type AuthResponse = import('./generated/types.generated').AuthResponse;
export type Authentication = import('./generated/types.generated').Authentication;
export type BaseUser = import('./generated/types.generated').BaseUser;
export type BaseUserWithType = import('./generated/types.generated').BaseUserWithType;
export type Candidate = import('./generated/types.generated').Candidate;
export type CandidateAI = import('./generated/types.generated').CandidateAI;
export type CandidateContact = import('./generated/types.generated').CandidateContact;
export type CandidateListResponse = import('./generated/types.generated').CandidateListResponse;
export type CandidateQuestion = import('./generated/types.generated').CandidateQuestion;
export type CandidateResponse = import('./generated/types.generated').CandidateResponse;
export type Certification = import('./generated/types.generated').Certification;
export type ChatContext = import('./generated/types.generated').ChatContext;
export type ChatMessage = import('./generated/types.generated').ChatMessage;
export type ChatMessageError = import('./generated/types.generated').ChatMessageError;
export type ChatMessageMetaData = import('./generated/types.generated').ChatMessageMetaData;
export type ChatMessageRagSearch = import('./generated/types.generated').ChatMessageRagSearch;
export type ChatMessageResume = import('./generated/types.generated').ChatMessageResume;
export type ChatMessageSkillAssessment = import('./generated/types.generated').ChatMessageSkillAssessment;
export type ChatMessageStatus = import('./generated/types.generated').ChatMessageStatus;
export type ChatMessageStreaming = import('./generated/types.generated').ChatMessageStreaming;
export type ChatMessageUser = import('./generated/types.generated').ChatMessageUser;
export type ChatOptions = import('./generated/types.generated').ChatOptions;
export type ChatQuery = import('./generated/types.generated').ChatQuery;
export type ChatResponse = import('./generated/types.generated').ChatResponse;
export type ChatSession = import('./generated/types.generated').ChatSession;
export type ChromaDBGetResponse = import('./generated/types.generated').ChromaDBGetResponse;
export type CreateCandidateRequest = import('./generated/types.generated').CreateCandidateRequest;
export type CreateEmployerRequest = import('./generated/types.generated').CreateEmployerRequest;
export type CustomQuestion = import('./generated/types.generated').CustomQuestion;
export type DataSourceConfiguration = import('./generated/types.generated').DataSourceConfiguration;
export type DesiredSalary = import('./generated/types.generated').DesiredSalary;
export type Document = import('./generated/types.generated').Document;
export type DocumentContentResponse = import('./generated/types.generated').DocumentContentResponse;
export type DocumentListResponse = import('./generated/types.generated').DocumentListResponse;
export type DocumentMessage = import('./generated/types.generated').DocumentMessage;
export type DocumentOptions = import('./generated/types.generated').DocumentOptions;
export type DocumentUpdateRequest = import('./generated/types.generated').DocumentUpdateRequest;
export type EditHistory = import('./generated/types.generated').EditHistory;
export type Education = import('./generated/types.generated').Education;
export type EmailVerificationRequest = import('./generated/types.generated').EmailVerificationRequest;
export type Employer = import('./generated/types.generated').Employer;
export type EmployerResponse = import('./generated/types.generated').EmployerResponse;
export type ErrorDetail = import('./generated/types.generated').ErrorDetail;
export type EvidenceDetail = import('./generated/types.generated').EvidenceDetail;
export type ExtraChatContext = import('./generated/types.generated').ExtraChatContext;
export type GPUInfo = import('./generated/types.generated').GPUInfo;
export type Guest = import('./generated/types.generated').Guest;
export type GuestCleanupRequest = import('./generated/types.generated').GuestCleanupRequest;
export type GuestConversionRequest = import('./generated/types.generated').GuestConversionRequest;
export type GuestSessionResponse = import('./generated/types.generated').GuestSessionResponse;
export type GuestStatistics = import('./generated/types.generated').GuestStatistics;
export type InterviewFeedback = import('./generated/types.generated').InterviewFeedback;
export type InterviewSchedule = import('./generated/types.generated').InterviewSchedule;
export type Job = import('./generated/types.generated').Job;
export type JobAnalysis = import('./generated/types.generated').JobAnalysis;
export type JobApplication = import('./generated/types.generated').JobApplication;
export type JobDetails = import('./generated/types.generated').JobDetails;
export type JobListResponse = import('./generated/types.generated').JobListResponse;
export type JobRequirements = import('./generated/types.generated').JobRequirements;
export type JobRequirementsExtraction = import('./generated/types.generated').JobRequirementsExtraction;
export type JobRequirementsMessage = import('./generated/types.generated').JobRequirementsMessage;
export type JobResponse = import('./generated/types.generated').JobResponse;
export type Language = import('./generated/types.generated').Language;
export type Location = import('./generated/types.generated').Location;
export type LoginRequest = import('./generated/types.generated').LoginRequest;
export type MFAData = import('./generated/types.generated').MFAData;
export type MFARequest = import('./generated/types.generated').MFARequest;
export type MFARequestResponse = import('./generated/types.generated').MFARequestResponse;
export type MFAVerifyRequest = import('./generated/types.generated').MFAVerifyRequest;
export type MessageReaction = import('./generated/types.generated').MessageReaction;
export type NotificationPreference = import('./generated/types.generated').NotificationPreference;
export type PaginatedRequest = import('./generated/types.generated').PaginatedRequest;
export type PaginatedResponse = import('./generated/types.generated').PaginatedResponse;
export type PersonaExtraction = import('./generated/types.generated').PersonaExtraction;
export type PointOfContact = import('./generated/types.generated').PointOfContact;
export type ProcessingStep = import('./generated/types.generated').ProcessingStep;
export type RAGConfiguration = import('./generated/types.generated').RAGConfiguration;
export type RAGDocumentRequest = import('./generated/types.generated').RAGDocumentRequest;
export type RagContentMetadata = import('./generated/types.generated').RagContentMetadata;
export type RagContentResponse = import('./generated/types.generated').RagContentResponse;
export type RagEntry = import('./generated/types.generated').RagEntry;
export type RateLimitConfig = import('./generated/types.generated').RateLimitConfig;
export type RateLimitResult = import('./generated/types.generated').RateLimitResult;
export type RateLimitStatus = import('./generated/types.generated').RateLimitStatus;
export type RefreshToken = import('./generated/types.generated').RefreshToken;
export type Requirements = import('./generated/types.generated').Requirements;
export type ResendVerificationRequest = import('./generated/types.generated').ResendVerificationRequest;
export type Resume = import('./generated/types.generated').Resume;
export type ResumeMessage = import('./generated/types.generated').ResumeMessage;
export type RetrievalParameters = import('./generated/types.generated').RetrievalParameters;
export type SalaryRange = import('./generated/types.generated').SalaryRange;
export type SearchQuery = import('./generated/types.generated').SearchQuery;
export type Skill = import('./generated/types.generated').Skill;
export type SkillAssessment = import('./generated/types.generated').SkillAssessment;
export type SkillAssessmentExtraction = import('./generated/types.generated').SkillAssessmentExtraction;
export type SkillMatchRequest = import('./generated/types.generated').SkillMatchRequest;
export type SocialLink = import('./generated/types.generated').SocialLink;
export type SystemInfo = import('./generated/types.generated').SystemInfo;
export type Tool = import('./generated/types.generated').Tool;
export type ToolCall = import('./generated/types.generated').ToolCall;
export type Tunables = import('./generated/types.generated').Tunables;
export type UsageStats = import('./generated/types.generated').UsageStats;
export type UserActivity = import('./generated/types.generated').UserActivity;
export type UserPreference = import('./generated/types.generated').UserPreference;
export type WorkExperience = import('./generated/types.generated').WorkExperience;
export type SkillAssessmentData = import('./generated/types.generated').SkillAssessmentData;
export type User = import('./generated/types.generated').User;

export {
  convertAnalyticsFromApi,
  convertApiMessageFromApi,
  convertApplicationDecisionFromApi,
  convertAttachmentFromApi,
  convertAuthResponseFromApi,
  convertAuthenticationFromApi,
  convertBaseUserFromApi,
  convertBaseUserWithTypeFromApi,
  convertCandidateFromApi,
  convertCandidateAIFromApi,
  convertCandidateListResponseFromApi,
  convertCandidateResponseFromApi,
  convertCertificationFromApi,
  convertChatMessageFromApi,
  convertChatMessageErrorFromApi,
  convertChatMessageRagSearchFromApi,
  convertChatMessageResumeFromApi,
  convertChatMessageSkillAssessmentFromApi,
  convertChatMessageStatusFromApi,
  convertChatMessageStreamingFromApi,
  convertChatMessageUserFromApi,
  convertChatSessionFromApi,
  convertDataSourceConfigurationFromApi,
  convertDocumentFromApi,
  convertDocumentListResponseFromApi,
  convertDocumentMessageFromApi,
  convertEditHistoryFromApi,
  convertEducationFromApi,
  convertEmployerFromApi,
  convertEmployerResponseFromApi,
  convertGuestFromApi,
  convertGuestSessionResponseFromApi,
  convertInterviewFeedbackFromApi,
  convertInterviewScheduleFromApi,
  convertJobFromApi,
  convertJobAnalysisFromApi,
  convertJobApplicationFromApi,
  convertJobDetailsFromApi,
  convertJobListResponseFromApi,
  convertJobRequirementsMessageFromApi,
  convertJobResponseFromApi,
  convertMessageReactionFromApi,
  convertRAGConfigurationFromApi,
  convertRateLimitResultFromApi,
  convertRateLimitStatusFromApi,
  convertRefreshTokenFromApi,
  convertResumeFromApi,
  convertResumeMessageFromApi,
  convertSkillAssessmentFromApi,
  convertUserActivityFromApi,
  convertWorkExperienceFromApi,
  convertFromApi,
  convertArrayFromApi,
} from './generated/types.generated';

export type { };
